var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{staticClass:"float-right btn-outline-secondary mr-2",attrs:{"variant":"light","size":"sm"},on:{"click":function($event){return _vm.copyData()}}},[_c('b-icon',{attrs:{"icon":"clipboard"}}),_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.copied ? 'copied' : 'Copy data'))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }